<template>
  <button-dialog-container
    :only-icon="onlyIcon"
    :btn-icon="icon"
    :btn-text="text"
    :width-dialog="700"
    :width="width"
    :height="height"
    :is-rounded="isRounded"
    :title-dialog="$t('project.open')"
    :is-from-creation-page="isFromCreationPage"
    @ok-pushed="openFile()"
  >
    <v-container>
      <v-card-subtitle>
        <v-row>
          <v-col cols="11">
            <v-text-field
              v-model="search"
              :label="$t('project.search')"
              :items="projects"
              class="players-autocomplete"
              hide-details
              single-line
              clearable
              dense
            />
          </v-col>
          <v-col cols="1">
            <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-row>
        <v-col>
          <v-data-table
            v-model="selectedProject"
            :headers="headers"
            :items="projects"
            :items-per-page="10"
            single-select
            show-select
            :search="search"
          />
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector";
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector";

// Tools
const pathInfo = require("path");
const ft = require("@/components/Tools/FileTools");

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    onlyIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: undefined,
    },
    height: {
      type: String,
      default: undefined,
    },
    isRounded: {
      type: Boolean,
      default: false,
    },
    isFromCreationPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectConnector: new ProjectConnector(this.$store.state.user),
      profileFavouriteConnector: new ProfileFavouriteConnector(this.$store.state.user),
      showSearch: false,
      mediacenterPath: "",
      projects: [],
      selectedProject: [],
      search: "",
      headers: [
        { text: this.$t("navbar.project"), align: "start", value: "name" },
        { text: this.$t("mediacenter.directory"), value: "nameDir" },
        { text: this.$t("project.width"), value: "width" },
        { text: this.$t("project.height"), value: "height" },
      ],
    };
  },
  created() {
    if (this.$store.state.user.socId != null) {
      this.getProject();
    }
  },
  methods: {
    // TODO: Triple declaration of checkExistProject method
    checkExistProject(element) {
      return new Promise(async (resolve, reject) => {
        const exist = await ft.exists("./" + element.path).catch((err) => {
          console.error(err);
          return reject(err);
        });

        if (exist) {
          return resolve(this.createObject(element));
        } else {
          // Add flag notfound on project
          let path = element.path;

          if (path.indexOf("./") == 0) {
            path = path.slice(2, path.length);
          }

          // TODO: Why not using project id instead of path ?
          this.projectConnector.addFlagNotfound(path);
          return reject("Project not found");
        }
      });
    },
    createObject(element) {
      let id_proj = element.id_proj;

      if (id_proj === undefined) {
        id_proj = element.proj_id;
      }

      // GET BASENAME WITHOUT EXTENSION
      const filename = pathInfo.basename(element.path, ".zip");

      // GET DIR IN MEDIACENTER + SOCID
      let dir = pathInfo.dirname(element.path);
      dir = dir.replace("mediacenter/" + this.$store.state.user.socId, "");
      dir = dir + "/";

      const project = {
        id: id_proj,
        name: filename,
        path: element.path,
        nameDir: dir,
        width: element.width,
        height: element.height,
        type: "project",
      };

      return project;
    },
    getProject() {
      const promises = [];
      this.projectConnector
        .getProject()
        .then((projects) => {
          for (const project of projects) {
            promises.push(
              this.checkExistProject(project).catch((err) => {
                console.warn(err);
                return null;
              })
            );
          }

          Promise.all(promises)
            .then((result) => {
              // Filter results to remove null values
              const validProjects = result.filter((element) => {
                if (element) return element;
              });

              // By default we get all projects
              this.projects = validProjects;

              // If dir limited for user we use this root path
              if (this.$store.state.user.dir != "") {
                // TODO: Could be done a better way ?
                const pathLimited = this.$store.state.user.dir.replace(this.$store.state.config.dirs.app, "");

                this.projects = result.filter((element) => {
                  if (element.path.includes(pathLimited)) {
                    return element;
                  }
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openFile() {
      if (this.selectedProject.length > 0) {
        if (this.isFromCreationPage) {
          console.warn("Open project | here in DialogOpenProject.vue");
          const projectData = {
            projId: this.selectedProject[0].id,
            projectName: this.selectedProject[0].name,
            savePath: this.selectedProject[0].path,
          };
          this.$emit("open-project", projectData);
        } else {
          this.openProject(this.selectedProject[0]);
        }
      } else {
        console.warn("No project selected");
      }
      this.selectedProject = [];
    },
    openProject(project) {
      this.profileFavouriteConnector.insertHistProject(project.id);

      const projectData = {
        projectName: project.name,
        savePath: project.path,
      };

      this.$store.dispatch("open", projectData).project;
      this.$router.push({ path: "/project/1" });
    },
  },
};
</script>

<style>
.players-autocomplete {
  top: 20%;
}

.players-autocomplete-slide-enter-active,
.players-autocomplete-slide-leave-active {
  transition: opacity 0.5s;
}

.players-autocomplete-slide-enter,
.players-autocomplete-slide-leave-to {
  opacity: 0;
}
</style>
